function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export default class CookiePopup {
    constructor() {
      if(document.querySelector('.nb--cookiepopup')){
        this.elements = {
          gtmCookie: document.querySelector('.nb--cookiepopup[data-nbcookie="gtmcookie"]'),
          cookieName: 'gtmCookieAccepted',
          popupCookie: getCookie('gtmCookiePopup'),
          radioButtons: document.querySelectorAll('.nb--cookiepopup__field--radio input'),
          requiredDiv: document.querySelector('.nb--cookiepopup__required'),
          languageDropdown: document.querySelector('.nb--cookiepopup__lang-dropdown'),
          languageContentElements: document.querySelectorAll('.nb--cookiepopup__translated'),

          settingsButtons: document.getElementsByClassName('js--nb-cookie-settings'),
          minimalRadio: document.querySelector('input[name=nbcookie][value=minimal]'),
          optimalRadio: document.querySelector('input[name=nbcookie][value=optimal]'),
          buttons: document.getElementsByClassName('js--nb-gtmcookie')
        }
        this.init();
        this._setDOMReferences();
      }
    }

  // $('.nb--cookiepopup__lang-dropdown').on('change', function() {
  //   $('div.nb--cookiepopup__translated').addClass('hidden');
  //   $('div.nb--cookiepopup__translated-' + $(this).val()).removeClass('hidden');
  // });


    _setDOMReferences() {
        for (let i = 0; i < this.elements.radioButtons.length; i++) {
            const el = this.elements.radioButtons[i];
            el.addEventListener('change', this.hideRequiredDiv);
        }

        for (let i = 0; i < this.elements.settingsButtons.length; i++) {
            const el = this.elements.settingsButtons[i];
            el.addEventListener('click', this.handleChangeSettings);
        }

        for (let i = 0; i < this.elements.buttons.length; i++) {
            const el = this.elements.buttons[i];
            el.addEventListener('click', this.handleButton.bind(this));
        }

        this.elements.languageDropdown.addEventListener('change', (event) => {
          let active = event.target.value;
          for (let i = 0; i < this.elements.languageContentElements.length; i++) {
            const element = this.elements.languageContentElements[i];
            if (element.classList.contains(`nb--cookiepopup__translated-${active}`)) {
              element.classList.remove('hidden');
              this.elements.introDiv = element.querySelector('.nb--cookiepopup__intro');
              this.elements.settingsDiv = element.querySelector('.nb--cookiepopup__settings');
            } else {
              element.classList.add('hidden');
            }
          }
        })
    }

    hideRequiredDiv() {
        this.elements.requiredDiv.style.display = 'none';
    }

    showRequiredDiv() {
        this.elements.requiredDiv.style.display = "block";
    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    init() {
      const defaultLanguage = this.elements.languageDropdown.value;
      const defaultLanguageElement = document.querySelector(`.nb--cookiepopup__translated-${defaultLanguage}`);

      this.elements.introDiv = defaultLanguageElement.querySelector('.nb--cookiepopup__intro');
      this.elements.settingsDiv = defaultLanguageElement.querySelector('.nb--cookiepopup__settings');


      if(!this.elements.popupCookie) {
        this.elements.gtmCookie.setAttribute('data-nbcookiestate', 'active');
      }
    }

    handleChangeSettings(e) {
        e.preventDefault();

        this.elements.gtmCookie.setAttribute('data-nbcookiestate', 'active');

        this.showSettingsTab();

        if(this.elements.popupCookie === 0) {
            this.elements.minimalRadio.checked = true;
        } else if(this.elements.popupCookie === 1) {
            this.elements.optimalRadio.checked = true;
        }
    }

    handleButton(e) {
        e.preventDefault();
        let answer = e.target.getAttribute('data-answer');


        if(answer === 'accept') {
            this.nbCookieAccepted();
        } else if(answer === 'settings') {
            this.showSettingsTab();
        } else if(answer === 'radio') {
            let checkedRadio = document.querySelector(
                'input[type=radio][name=nbcookie]:checked'
            );
            if(checkedRadio) {
                checkedRadio.value === "optimal" ?
                    this.nbCookieAccepted() :
                    this.nbCookieDeclined();
            } else {
                this.showRequiredDiv();
            }
        } else {
            this.nbCookieDeclined();
        }
    }

    showSettingsTab() {
        this.elements.introDiv.style.display = "none";
        this.elements.settingsDiv.style.display = "block";
    }

    nbCookieAccepted() {
        this.setCookie('gtmCookieAccepted', 1, 1095);
        this.setCookie('gtmCookiePopup', 1, 1095);

        location.reload();
    }

    nbCookieDeclined() {
        this.setCookie('gtmCookieAccepted', 0, 1095);
        this.setCookie('gtmCookiePopup', 1, 1095);

        location.reload();
    }
}
